import Logo from "../../images/parkandflylogo.png";
import PhoneIcon from "../../icons/phone.svg";
import MailIcon from "../../icons/email.svg";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-col footer-brand">
          <img src={Logo} alt="ParkNFly" className="footer-logo" loading="lazy" />
          <p className="footer-description">
            Pigus automobilių parkavimas prie Kauno oro uosto.
          </p>
        </div>
        <div className="footer-col">
          <h4>Kontaktai</h4>
          <ul>
            <li><img src={PhoneIcon} className="contacts-icon" loading="lazy" alt="Telefonas" /> +370 600 11 103</li>
            <li><img src={MailIcon} className="contacts-icon" loading="lazy" alt="Email" /> info@parknfly.lt</li>
          </ul>
        </div>
        <div className="footer-col">
          <h4>Rekvizitai</h4>
          <ul>
            <li>Parkavimo paslauga, MB</li>
            <li>Įmonės kodas: 306671589</li>
          </ul>
        </div>
      </div>
      <hr className="footer-divider" />
      <p className="footer-bottom">
        © {new Date().getFullYear()} ParkNFly. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
